module.exports = __webpack_public_path__ + "static/img/102273.276b049f.png";